import React from 'react'

import {
  BetaLabel,
  InformationIcon,
  Loading,
} from '@/components/customComponents'
import { Button } from '@/components/ui/button'
import { Card, CardFooter } from '@/components/ui/card'
import { IconChevronRight } from '@tabler/icons-react'

type ContentCardProps = {
  title: string
  loading?: boolean
  showViewMore?: boolean
  onViewMore?: () => void
  children: React.ReactNode
  infoDescription?: string
  showCard?: boolean
  customButton?: React.ReactNode
  className?: string
  isBeta?: boolean
}

// TODO: remove showViewMore, only onViewMore is enough
const ContentCard: React.FC<ContentCardProps> = ({
  title,
  loading = false,
  showViewMore = false,
  onViewMore,
  children,
  infoDescription,
  showCard = true,
  customButton,
  className,
  isBeta = false,
}) => {
  return (
    <Card
      className={`flex flex-col h-full ${showCard ? '' : 'border-none'} ${className}`}
    >
      <div
        className={`flex justify-between items-center p-4 ${!showViewMore && 'pt-6'} ${showCard ? '' : '!p-2'}`}
      >
        <div className="flex flex-row items-center gap-2">
          <span className="leading-none tracking-tight text-black-500 text-display-s">
            {title}
          </span>
          {infoDescription && <InformationIcon description={infoDescription} />}
        </div>

        {showViewMore && onViewMore && (
          <Button size="sm" variant="outline" onClick={onViewMore}>
            View More <IconChevronRight className="h-4 w-4 ml-1" />
          </Button>
        )}

        {customButton && !loading && customButton}
      </div>
      {loading ? (
        <div className="flex-1 flex justify-center items-center p-4">
          <Loading />
        </div>
      ) : (
        <div className="flex flex-col p-2 pt-0 flex-1 justify-between">
          <div></div>
          {children}
          <div></div>
        </div>
      )}
      {isBeta && (
        <CardFooter className="flex justify-end items-end p-0">
          <BetaLabel />
        </CardFooter>
      )}
    </Card>
  )
}

export { ContentCard }
